export default {
  EnumResource: {
    // Giới tính
    Gender: {
      Female: 'Nữ',
      Male: 'Nam'
    },
    // Loại đáp án
    AnswerType: {
      Compose: 'Soạn đáp án',
      Upload: 'Tải lên đáp án và lời giải'
    },
    // Loại câu hỏi
    QuestionType: {
      Yesorno: 'Đúng sai', // Đúng sai
      Group: 'Câu hỏi nhóm', // Ghép đôi
      Select: 'Chọn đáp án', // Chọn đáp án
      Fill: 'Điền vào chỗ trống', // Điền từ
      Essay: 'Tự luận', // Tự luận
      Pairing: 'Ghép - nối'
    },
    /**
   * Sắp xếp tab Học sinh màn hình tổng quan chi tiết
   */
    RankingSortType: {
      Ranking: 'Xếp theo thứ hạng',
      StudentName: 'Xếp theo tên học sinh',
      SubmitRateAsc: 'Tỉ lệ nộp bài tăng dần',
      SubmitRateDesc: 'Tỉ lệ nộp bài giảm dần',
      CorrectRateAsc: 'Tỉ lệ đúng tăng dần',
      CorrectRateDesc: 'Tỉ lệ đúng giảm dần'
    },

    /**
   * Sắp xếp tab Bài tập màn hình tổng quan chi tiết
   */
    ExerciseSortType: {
      SortWeek: 'Xếp theo tuần',
      SubmitRateAsc: 'Tỉ lệ nộp bài tăng dần',
      SubmitRateDesc: 'Tỉ lệ nộp bài giảm dần',
      CorrectRateAsc: 'Tỉ lệ đúng tăng dần',
      CorrectRateDesc: 'Tỉ lệ đúng giảm dần'
    },

    /**
   * tab trong view học sinh làm bài
   */
    ExerciseStoreTab: {
      Topics: 'Đề bài',
      Documents: 'Bài giảng'
    },

    /**
     * Sắp xếp tab Chủ đề màn hình tổng quan chi tiết
     */
    TopicSortType: {
      Program: 'Xếp theo phân phối chương trình',
      NumberExerciseAsc: 'Số bài giao tăng dần',
      NumberExerciseDesc: 'Số bài giao giảm dần',
      CorrectRateAsc: 'Tỉ lệ đúng tăng dần',
      CorrectRateDesc: 'Tỉ lệ đúng giảm dần'
    },

    /**
     * Chức vụ của giáo viên trong trường
     */
    TeacherPosition: {
      Other: 'Khác',
      Principal: 'Hiệu trưởng',
      VicePrincipal: 'Hiệu phó',
      Teacher: 'Giáo viên'
    },

    Theme: {
      Basic: 'Giao diện cơ bản',
      Fun: 'Giao diện vui nhộn'
    },

    /**
     *
     */
    ShareType: {
      Library: 'Lấy từ thư viện',
      DoneShared: 'Đã chia sẻ',
      NoShared: 'Chưa chia sẻ',
      Draft: 'Đang soạn',
      Complete: 'Đã soạn',
      ExamShare: 'Bài kiểm tra của tôi chia sẻ'
    },

    TimePeriod: {
      DispersionExam: 'Học sinh làm bài trong khoảng thời gian', // thi tập chung,
      GeneralExam: 'Học sinh làm bài cùng thời điểm' // thi phân tán
    },

    SchoolTimePeriod: {
      DispersionExam: 'Làm bài trong khoảng thời gian', // thi tập chung,
      GeneralExam: 'Làm bài cùng thời điểm' // thi phân tán
    },

    Time: {
      Time15: '15 phút',
      Time30: '30 phút',
      Time45: '45 phút',
      Time60: '60 phút'
    },

    /**
     * Loại bài kiểm tra
     */
    TypeExam: {
      ExamSchool: 'Theo kế hoạch kiểm tra của trường',
      ExamTeacher: 'Giáo viên tự tổ chức kiểm tra'
    },

    AssignType: {
      ClassDelivery: 'Giao theo lớp',
      ListStudentDelivery: 'Giao theo danh sách học sinh'
    },

    /**
     * Cách thức nhập điểm
     */
    PointType: {
      PointCoefficient: 'Nhập theo hệ số', // Theo hệ số điểm
      PointLadder: 'Nhập theo thang điểm' // Theo thang điểm
    },

    /**
     * Mức độ câu hỏi
     */
    QuestionLevel: {
      Easy: 'Dễ', // Dễ
      Normal: 'TB', // Bình thường
      Hard: 'Khó' // Khó
    },

    /**
     * Thời gian làm bài kiểm tra
     */
    ExamTime: {
      Fifteen: '15 phút',
      Thirty: '30 phút',
      FortyFive: '45 phút',
      Sixty: '60 phút',
      Ninety: '90 phút',
      OneHundredAndTwenty: '120 phút'
    },

    /**
   * Trạng thái tìm kiếm học sinh trong bài kiểm tra
   */
    StudentExamPeriodStatus: {
      All: 'Tất cả',
      IsJoin: 'Đang làm bài',
      NotJoinYet: 'Chưa tham gia',
      Marked: 'Đã chấm',
      NotMark: 'Chưa chấm',
      IsReady: 'Đang chờ',
      Submited: 'Đã nộp bài',
      NotJoin: 'Chưa tham gia',
      NotSubmited: 'Không tham gia'
    },

    /**
   * Trạng thái tìm kiếm học sinh trong bài kiểm tra
   */
    StudentSchoolExamPeriodStatus: {
      All: 'Tất cả trạng thái',
      IsJoin: 'Đang làm bài',
      NotJoin: 'Chưa tham gia',
      IsReady: 'Đang chờ',
      Submited: 'Đã nộp bài',
      NotSubmited: 'Không tham gia'
    },

    /**
   * Trạng thái tìm kiếm bài kiểm tra hội đồng tổ chức
   */
    StatusSchoolExamPeriodFilter: {
      All: 'Tất cả',
      NotOpen: 'Chưa diễn ra',
      WaitingOpenTopic: 'Chờ mở đề',
      Processing: 'Đang kiểm tra',
      Over: 'Đã kết thúc'
    },

    /**
     * Trạng thái bài tập
     */
    ExerciseStatus: {
      SaveDraft: 'Lưu nháp', // Lưu nháp
      Complete: 'Hoàn thành', // Hoàn thành
      Share: 'Chia sẻ',
      StopShare: 'Ngừng chia sẻ'
    },

    ExamStatus: {
      MyPost: 'Bài của tôi', // Bài của tôi
      AssignComposing: 'Soạn đề', // Phân công soạn
      DotAssignment: 'Chấm bài' // Phân công chấm
    },
    ExamStatusFilter: {
      IsDone: 'Đã kết thúc', // Đã kết thúc
      NotDone: 'Chưa hoàn thành' // Chưa hoàn thành
    },

    // Trạng thái bài tập của học sinh
    ExerciseStatusFilter: {
      NotFinish: 'Chưa hoàn thành',
      Finished: 'Đã hoàn thành'
    },

    ExerciseShare: {
      MyShare: 'Học liệu của tôi chia sẻ'
    },

    ExerciseChoose: {
      CancelAllChoose: 'Bỏ chọn tất cả',
      AllChoose: ' Chọn tất cả'
    },

    /**
     * Trạng thái soạn
     */
    ComposingStatus: {
      Uncomposed: 'Chưa soạn',
      Composed: 'Đã soạn'
    },

    /**
     * Nguồn học liệu
     */
    SourceTypeCourse: {
      ALL: 'Tất cả các nguồn',
      HOCMAI: 'HOCMAI.VN',
      IGIAODUC: 'Học liệu số BGD',
      HANHTRANGSO: 'NXB Giáo dục',
      CONTUHOC: 'Con Tự Học',
      EMIS: 'Cộng đồng giáo viên'
    },

    /**
     * Nguồn học liệu
     */
    LibraryCourseType: {
      All: 'Tất cả học liệu',
      Practice: 'Bài tập',
      ConsolidateKnowledge: 'Khóa học'
    },

    /**
    * enum filter học liệu của tôi
    */
    MyCourseStatus: {
      NotYet: 'Chưa học',
      Learning: 'Đang học',
      Learned: 'Đã học'
    },

    /**
     * học liệu miễn phí / mất phí
     */
    TakeCharge: {
      All: 'Tất cả',
      NotFree: 'Mất phí',
      Free: 'Miễn phí'
    },

    /**
     * Thời gian làm bài kiểm tra
     */
    GameTime: {
      Fifteen: '15',
      Thirty: '30',
      FortyFive: '45',
      Sixty: '60',
      Ninety: '90',
      OneHundredAndTwenty: '120',
      OneHundredAndEighty: '180',
      TwoHundredAndForty: '240',
      ThreeHundred: '300'
    },

    ReasonType: {
      ReasonOther: 'Lý do khác',
      ProductNotGood: 'Sản phẩm không đáp ứng nhu cầu',
      ProductError: 'Sản phẩm hay bị lỗi',
      SupportServiceNotGood: 'Dịch vụ tư vấn hỗ trợ khách hàng kém',
      HighPrice: 'Giá thành cao',
      UseConvenient: 'Thao tác sử dụng không thuận tiện',
      SlowProcessingSpeed: 'Tốc độ xử lý chậm',
      SecurityNotGood: 'Bảo mật phần mềm kém'

    },

    StudentFilterExamStatus: {
      All: 'Tất cả',
      NotFinish: 'Chưa hoàn thành',
      Finished: 'Đã kết thúc'
    },
    // tab màn chi tiết bài kiểm tra
    ExamDetailTab: {
      Monitoring: 'Giám sát',
      Exam: 'Đề kiểm tra'
    },

    ContentError: {
      QuestionWrong: 'Câu hỏi sai',
      AnswerWrong: 'Đáp án sai',
      TheAnswerWrong: 'Lời giải sai',
      Other: 'Khác'
    },

    TypeError: {
      SpellingError: 'Lỗi chính tả',
      GrammaticalError: 'Lỗi ngữ pháp',
      WrongContent: 'Sai nội dung',
      Other: 'Khác'

    }
  }
}
